"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useId = void 0;
var _react = require("react");
var _utils = require("../utils");
/**
 * @deprecated Code component is deprecated. Use CodeSnippet component or inline `<code>` instead.
 */
const useId = () => {
  const id = (0, _react.useId)();
  if (_utils.IS_DEV) {
    console.warn('The useId hook has been deprecated. Use `import { useId } from "react";` instead.');
  }
  return id;
};
exports.useId = useId;